import React, { createContext, useContext, useState } from 'react';


export interface ICampaignPoliticalAdsDeclarationContext {
  isDeclarationCompleted: boolean;
  setIsDeclarationCompleted: (value: boolean) => void;
}

export const CampaignPoliticalAdsDeclarationContext = createContext<ICampaignPoliticalAdsDeclarationContext | undefined>(undefined);

export interface ICampaignPoliticalAdsDeclarationProviderProps {
  isDeclarationCompletedInitially?: boolean;
  children: React.ReactNode;
}

export interface ICampaignPoliticalAdsDeclarationInjectedProps {
  isDeclarationCompleted: boolean;
  setIsDeclarationCompleted: (value: boolean) => void;
}

export const CampaignPoliticalAdsDeclarationProvider = ({ isDeclarationCompletedInitially, children }: ICampaignPoliticalAdsDeclarationProviderProps) => {
  const [isDeclarationCompleted, setIsDeclarationCompleted] = useState(isDeclarationCompletedInitially || false);

  return (
    <CampaignPoliticalAdsDeclarationContext.Provider value={{ isDeclarationCompleted, setIsDeclarationCompleted }}>
      {children}
    </CampaignPoliticalAdsDeclarationContext.Provider>
  );
};

CampaignPoliticalAdsDeclarationProvider.defaultProps = {
  isDeclarationCompletedInitially: false,
};

export const withCampaignPoliticalAdsDeclaration = <P extends object>(
  WrappedComponent: React.ComponentType<P & ICampaignPoliticalAdsDeclarationInjectedProps>
) => {
  const HOC = (props: P) => {
    const context = useContext(CampaignPoliticalAdsDeclarationContext);
    if (!context) {
      throw new Error('withCampaignPoliticalAdsDeclaration must be used within a CampaignPoliticalAdsDeclarationProvider');
    }

    const { isDeclarationCompleted, setIsDeclarationCompleted } = context;

    return (
      <WrappedComponent
        {...props}
        isDeclarationCompleted={isDeclarationCompleted}
        setIsDeclarationCompleted={setIsDeclarationCompleted}
      />
    );
  };
  return HOC;
};
